<p-dialog
    [(visible)]="visible"
    [modal]="true"
    appendTo="body"
    [header]="'workplace.label' | translate"
>
    <div class="grid-3col_auto mt-3 input-grid-gaps">
        <app-select-input
            id="workplaceId"
            [form]="form"
            [staticOptions]="store.workplaces$ | async"
            label="workplace.label"
            valueKey="id"
            labelKey="name">
        </app-select-input>
        <app-date-input [form]="form" id="dateFrom"></app-date-input>
        <app-date-input [form]="form" id="dateTo" timeType="endOfDay"></app-date-input>
    </div>

    @if (err) {
        <div class="text-danger mt-2">{{ err | translate }}</div>
    }

    <ng-template pTemplate="footer">
        <app-action-buttons (primaryClickEvent)="save()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
